// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

import { SAVE_PERSONALIZED_PAGE_HTML, SET_LOADING_PERSONALIZED } from '../actions/personalized';

// =================ACTIONS=====================

// ==============================================
// ================InitialState==================
// ==============================================
const initialState = {
  personalizedPageData: {},
  loadingPersonalized: true,
};

function personalizedReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_PERSONALIZED_PAGE_HTML:
      return {
        ...state,
        personalizedPageData: action.value,
      };
    case SET_LOADING_PERSONALIZED:
      return {
        ...state,
        loadingPersonalized: action.value,
      };
    default:
      return state;
  }
}

export default personalizedReducer;
